import { ITheme, IStyle, mergeStyleSets, getTheme, Icon } from '@fluentui/react';
import React from 'react';
import { BwjPalette } from '../../../../app-core/app-theme';

interface IPriceChangeNoteProps {
  priceChange: number;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    padding: '0.6rem',
    display: 'flex',
    alignItems: 'stretch',
    border: '1px solid white',
    borderLeft: 'none',
    borderRight: 'none',

    '& > p': {
      fontSize: theme.fonts.small.fontSize,
      lineHeight: theme.fonts.smallPlus.lineHeight,
      margin: 0,
      padding: 0,
      marginLeft: '0.25rem',
      flexGrow: 1,
    },
  };

  const upRoot: IStyle = {
    ...root,
    backgroundColor: BwjPalette.themeInfoBackground,
    borderColor: BwjPalette.themeInfo,
    color: BwjPalette.themeInfo,
  };

  const downRoot: IStyle = {
    ...root,
    backgroundColor: BwjPalette.themeSuccessBackground,
    borderColor: BwjPalette.themeSuccess,
    color: BwjPalette.themeSuccess,
  };

  const iconContainer: IStyle = {
    theme: 0,
    padding: 0,
    paddingRight: '0.25rem',

    '& > i': {
      fontSize: theme.fonts.large.fontSize,
    },
  }

  return mergeStyleSets({
    upRoot,
    downRoot,
    iconContainer,
  });
}

export const PriceChangeNote: React.FunctionComponent<IPriceChangeNoteProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const iconName = props.priceChange > 0 ? 'Info' : 'Balloons';
  const rootClass = props.priceChange > 0 ? cs.upRoot : cs.downRoot;
  const change = Math.abs(props.priceChange / 100);
  const message = props.priceChange > 0
    ? (<p><strong>Heads up</strong> &ndash; The price of this door has increased by <strong>${change.toFixed(2)}</strong> since the last time you looked at it. We value transparency, so we want to make sure you are aware of the change.</p>)
    : (<p><strong>Great news</strong> &ndash; The price of this door has dropped by <strong>${change.toFixed(2)}</strong> since the last time you looked at it. Hooray for savings!</p>);

  return (
    <div className={rootClass}>
      <div className={cs.iconContainer}>
        <Icon
          iconName={iconName}
          aria-hidden={true}
        />
      </div>
      {message}
    </div>
  );
};
